import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e3f63cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "box-box" }
const _hoisted_3 = { class: "table" }

import { ArrowRight } from "@element-plus/icons-vue";
import { onMounted, ref } from "vue";
import finance from "@/api/finance";
import { useRoute } from "vue-router";
import Padding from "@/components/Layout/paging.vue";
import { EnterpriseServiceTypeName } from "@/services/datatype/business/service/EnterpriseServiceTypeName";
import { DateFormat } from "@/services/util/DateFormat";
import cycle from "@/utils/CycleUtils";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

export default /*#__PURE__*/_defineComponent({
  __name: 'ViewDetails',
  setup(__props) {

const route = useRoute();
//导出表格
const exportExcel = () => {
  /* 从表生成工作簿对象 */
  let wb = XLSX.utils.table_to_book(document.querySelector("#out-table"));
  /* 获取二进制字符串作为输出 */
  let about = XLSX.write(wb, {
    bookType: "xlsx",
    bookSST: true,
    type: "array",
  });
  try {
    FileSaver.saveAs(
      //Blob 对象表示一个不可变、原始数据的类文件对象。
      //Blob 表示的不一定是JavaScript原生格式的数据。
      //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
      //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
      new Blob([about], { type: "application/octet-stream" }),
      //设置导出文件名称
      cycle.timeToCycle(route.params.id.toString()) + "账单明细.xlsx"
    );
  } catch (e) {
    if (typeof console !== "undefined") console.log(e, about);
  }
  return about;
};
//表格内容
const tableData = ref([]);
const newData = ref([]);
//获取内容
const getDataOne = (data) => {
  newData.value = data;
};
//获取信息
const getData = async () => {
  const tableDataOne: any = (
    await finance.getDetails(Number(route.params.id))
  ).getPageData();
  tableDataOne.forEach((value, index) => {
    value.index = index + 1;
  });
  tableData.value = tableDataOne;
};
onMounted(async () => {
  await getData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_breadcrumb, {
        "separator-icon": _unref(ArrowRight) as any
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_breadcrumb_item, { to: {path:'/layout/home'} as any }, {
            default: _withCtx(() => [
              _createTextVNode("首页")
            ]),
            _: 1
          }),
          _createVNode(_component_el_breadcrumb_item, { to: {path:'/layout/finance',query:{state:'false'
        }} as any }, {
            default: _withCtx(() => [
              _createTextVNode("财务结算")
            ]),
            _: 1
          }),
          _createVNode(_component_el_breadcrumb_item, null, {
            default: _withCtx(() => [
              _createTextVNode("查看明细")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["separator-icon"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: exportExcel
      }, {
        default: _withCtx(() => [
          _createTextVNode("导出表格")
        ]),
        _: 1
      }),
      _createVNode(_component_el_table, {
        data: tableData.value,
        id: "out-table",
        border: "",
        stripe: "",
        style: {"display":"none"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "index",
            label: "序号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "completionTime",
            label: "完成时间"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_unref(DateFormat).dateFormatString(Number(scope.row.completionTime), 3)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "enterpriseServiceType",
            label: "服务类型"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_unref(EnterpriseServiceTypeName).getDisplayName(
              scope.row.enterpriseServiceType
            ) + scope.row.preSale
              ? "(售前)"
              : ""), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "orderId",
            label: "订单号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "settleAmount",
            label: "金额"
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_component_el_table, {
        data: newData.value,
        border: "",
        stripe: "",
        height: "440"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "index",
            label: "序号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "completionTime",
            label: "完成时间"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_unref(DateFormat).dateFormatString(Number(scope.row.completionTime), 3)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "enterpriseServiceType",
            label: "服务类型"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_unref(EnterpriseServiceTypeName).getDisplayName(
              scope.row.enterpriseServiceType
            )), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "enterpriseServiceType",
            label: "负责人"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.assistantInfo?.entityName || "未分配"), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "orderId",
            label: "订单号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "settleAmount",
            label: "金额"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.settleAmount || 0), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createVNode(Padding, {
      data: tableData.value,
      "page-size": 10,
      onGetData: getDataOne
    }, null, 8, ["data"])
  ]))
}
}

})